export default "__VITE_ASSET__b64d0975__"